/**
 * Blocca l'invio dei form con checkbox privacy obbligatorie non selezionate.
 * Serve anche per i form con novalidate, dove l'attributo required viene ignorato.
 */
(function () {
  function toggleError(input, show) {
    var error = document.getElementById(input.id + '-error');
    if (error) error.hidden = !show;
    input.setAttribute('aria-invalid', show ? 'true' : 'false');
  }

  document.addEventListener('submit', function (event) {
    var unchecked = event.target.querySelectorAll('[data-privacy-required]:not(:checked)');
    if (!unchecked.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    Array.prototype.forEach.call(unchecked, function (input) {
      toggleError(input, true);
    });
    unchecked[0].focus();
  }, true);

  document.addEventListener('invalid', function (event) {
    if (event.target.matches('[data-privacy-required]')) toggleError(event.target, true);
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-privacy-required]')) toggleError(event.target, !event.target.checked);
  });
})();
